module.exports = __webpack_public_path__ + "static/media/generic-pipette-empty.124b9679.svg";